module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }